import { useAuth } from '@/contexts/AuthContext';
import { 
  hasPermission, 
  canRead as canReadUtil, 
  canWrite as canWriteUtil, 
  canDelete as canDeleteUtil,
  isRevenueManager as isRevenueManagerUtil,
  isRevenueStaff as isRevenueStaffUtil,
  hasFullAccess as hasFullAccessUtil,
  type PermissionAction
} from '@/utils/permissions';

export function usePermissions() {
  const { currentUser } = useAuth();

  return {
    currentUser,
    canRead: canReadUtil(currentUser),
    canWrite: canWriteUtil(currentUser),
    canDelete: canDeleteUtil(currentUser),
    isRevenueManager: isRevenueManagerUtil(currentUser),
    isRevenueStaff: isRevenueStaffUtil(currentUser),
    hasFullAccess: hasFullAccessUtil(currentUser),
    hasPermission: (action: PermissionAction) => hasPermission(currentUser, action),
  };
}
